import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Pages.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';

const articles = [
    {
        title: 'How to Transition to a Central Semantic Layer – Accelerate Your Data Value',
        link: '/insights/article-1',
        image: images.news1
    },
    {
        title: 'Introduction to Semantic Layers – The Gateway to Smarter Data Analytics',
        link: '/insights/article-2',
        image: images.news2
    },
    {
        title: 'Why Centralizing the Semantic Layer Trumps BI-Specific Architectures',
        link: '/insights/article-3',
        image: images.news3
    }
];

const caseStudiesData = [
    {
        title: 'Unified Data for Smarter Insurance Decisions',
        image: images.newcase3,
        to: '/case-studies/insurance'
    },
    {
        title: 'Modernizing Compliance & Reporting with Data at Scale',
        image: images.newcase2,
        to: '/case-studies/banking'
    },
    {
        title: 'Building a Trusted Data Foundation for Financial Services',
        image: images.newcase1,
        to: '/case-studies/financial-services'
    },
    {
        title: 'A Single Customer View for Better Airline Experiences',
        image: images.newcase4,
        to: '/case-studies/airline'
    }
];

function Insights() {
    useEffect(() => {
        document.title = "Insights | Datamatics Consulting";
    }, []);
    return (
        <>
            <section className="hero-static insights-hero">
                <div className="hero-slide-wrapper">
                    <img src={images.mech} alt="Expert tech and industry opinions" className="hero-background-image" />
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <h1 className="hero-title-insights">EXPERT TECH & INDUSTRY OPINIONS</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="news-section container">
                <div className="news-header">
                    <div className="subservice-title-wrapper-sub">
                        <div className="purple-line-sub"></div>
                        <h5>News & Articles</h5>
                    </div>
                </div>
                <div className="news-grid">
                    {articles.map((article, index) => (
                        <Link
                            key={index}
                            to={article.link}
                            className="news-card"
                        >
                            <div
                                className="news-card-bg"
                                style={{ backgroundImage: `url(${article.image})` }}
                            ></div>

                            <div className="news-card-content">
                                <h3>{article.title}</h3>

                                <div className="news-card-pill-btn">
                                    Learn More →
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            {/* Case Studies Section */}
            <section className="case-studies-section container-insights">
                <div className="case-studies-header">
                    <div className="purple-line-sub"></div>
                    <span className="case-studies-label">Relevant Projects</span>
                </div>
                <div className="case-studies-grid">
                    {caseStudiesData.slice(0, 3).map((study, index) => (
                        <div
                            key={index}
                            className="case-study-card"
                            onClick={() => handleLinkClick(study.to)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="case-study-image-wrapper">
                                <img src={study.image} alt={study.title} />
                            </div>
                            <h3 className="case-study-title">{study.title}</h3>
                            <a href={study.to} className="case-study-read-more" onClick={(e) => { e.preventDefault(); handleLinkClick(study.to); }}>
                                Read More →
                            </a>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
}

export default Insights;